import React, { useState, useMemo, useEffect, useCallback, SetStateAction, Dispatch } from 'react'
import { Pagination } from '../pagination/pagination'
import { SearchInput } from './SearchInput'
import { Translates } from '@/services/repository/i18n'
import { Spinner } from '../spinner'

import './SearchTable.css'

export interface StaticPaginatedTableState {
    pageNumber: number,
    pageSize: number
}

export interface StaticPaginatedTableParams<T> {
    data: T[]
    toolboxLeft?: () => React.ReactElement
    toolboxRight?: () => React.ReactElement
    header?: () => React.ReactElement
    row: (
        row: T,
        currentPage: T[],
        setPageRows: React.Dispatch<React.SetStateAction<T[]>>
    ) => React.ReactElement
    // initialState?: {
    //     pageSize: number
    // }
    parentState?: StaticPaginatedTableState
    setParentState?: Dispatch<SetStateAction<StaticPaginatedTableState>>
    translates: Translates
    className?: string
    filterFn?: (row: T, search: string) => boolean // Optional: customize search
}

export function StaticPaginatedTable<T>({
    data,
    row,
    header,
    toolboxLeft,
    toolboxRight,
    translates,
    className,
    filterFn,
    parentState,
    setParentState
    // initialState
}: StaticPaginatedTableParams<T>) {
    const [localState, setLocalState] = useState<StaticPaginatedTableState>({
        pageNumber: 1,
        pageSize: 30
    })
    // const [paginatedRows, setPaginatedRows] = useState<T[]>()
    // const [totalPages, setTotalPages] = useState<number>()

    // Determine whether component is controlled by parent
    const isControlled = parentState !== undefined && setParentState !== undefined;

    // Use parent state if controlled, otherwise local state
    const state = isControlled ? parentState : localState;
    const setState = isControlled ? setParentState : setLocalState;

    // const mathPaginatedRows = () => {
    //     let rows = data.slice((state.pageNumber - 1) * state.pageSize, state.pageNumber * state.pageSize)
    //     return rows
    // }

    // useEffect(() => {
    //     setState({
    //         ...state,
    //         pageNumber: 1
    //     })
    // }, [data])

    const paginatedRows = useMemo(() => {
        let rows = data.slice((state.pageNumber - 1) * state.pageSize, state.pageNumber * state.pageSize)
        return rows
    }, [data, state])

    const totalPages = useMemo(() => {
        return Math.max(1, Math.ceil(data.length / state.pageSize))
    }, [data, state])

    // useEffect(() => {
    //     setPaginatedRows(mathPaginatedRows())
    //     // setState({
    //     //     ...state,
    //     //     pageNumber: 1
    //     // })
    // }, [data, state])

    // useEffect(() => {
    //     setPaginatedRows(mathPaginatedRows())
    // }, [state])

    // useEffect(() => {
    //     const mathTotalPages = () => Math.max(1, Math.ceil(data.length / state.pageSize))
    //     setTotalPages(mathTotalPages())
    // }, [data, state])

    // Pagination logic
    // const paginatedRows = useMemo(
    //     () => {
    //         let rows = data.slice((state.pageNumber - 1) * state.pageSize, state.pageNumber * state.pageSize)
    //         console.log('rows', rows)
    //         return rows
    //     },
    //     [data, state]
    // )

    // const totalPages = useMemo(
    //     () => Math.max(1, Math.ceil(data.length / state.pageSize)),
    //     [paginatedRows, state]
    // )

    if(paginatedRows === undefined || totalPages === undefined) {
        return <Spinner />
    }

    const handlePageChange = (next: { pageSize: number; pageNumber: number }) => {
        setState(prev => ({
            ...prev,
            pageSize: next.pageSize,
            pageNumber: next.pageNumber,
        }))
    }

    return (
        <div className={className || 'main-search-table'}>
            {toolboxLeft || toolboxRight ? <div className="toolbox">
                <div className="left">{toolboxLeft && toolboxLeft()}</div>
                <div className="right">{toolboxRight && toolboxRight()}</div>
            </div> : null}
            <div className="search-body-wrap">
                <div className="search-body">
                    {header && <div className="row header">{header()}</div>}
                    {paginatedRows.map(item => (
                        <div className="row" key={(item as any).id}>
                            {row(item, paginatedRows, () => { })}
                        </div>
                    ))}
                </div>
            </div>
            {!paginatedRows.length && (
                <div className="empty-search-table-message">
                    {translates.for('elements.search.empty_table')}
                </div>
            )}
            <Pagination
                translates={translates}
                pageQuery={{
                    pageSize: state.pageSize,
                    pageNumber: state.pageNumber,
                    totalPages
                }}
                onChange={handlePageChange}
            />
        </div>
    )
}